function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 120",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.791,
    height: 21.439,
    viewBox: "0 0 25.791 21.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yp8dsai6ba"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 76",
    style: {
      fill: "none"
    },
    d: "M0 0h25.791v21.439H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 75",
    transform: "translate(3.682 1.913)",
    style: {
      stroke: "#f9d10e",
      strokeWidth: ".4px",
      fill: "none"
    },
    d: "M0 0h16.77v16.648H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 118",
    style: {
      clipPath: "url(#yp8dsai6ba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "M.142 8.613S6.294 11.569 9.676 21.1A67.505 67.505 0 0 1 25.418.107S20.112-1.521 9.733 12.6c0 0-3.62-5.61-9.591-3.982",
    transform: "translate(.16 .056)",
    style: {
      fill: "#f9d10e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45",
    d: "M.142 8.613S6.294 11.569 9.676 21.1A67.505 67.505 0 0 1 25.418.107S20.112-1.521 9.733 12.6c0 0-3.619-5.615-9.591-3.987z",
    transform: "translate(.16 .056)",
    style: {
      stroke: "#fff",
      strokeWidth: ".1px",
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.35e34f1e61b40be50babc8323ebb8938.svg";
export { ForwardRef as ReactComponent };